export default function Logo({ type = 'logo', className = '', ...props }) {
    let logoSrc = '/images/logo/logo.png'
    let maxW = 'max-w-44'

    if (type === 'dark') {
        logoSrc = '/images/logo/logo-dark.png'
    }

    return <img src={logoSrc} alt={type} className={`${maxW} ${className}`} {...props} />
}
